export default {"src":"/_next/static/image/public/images/aster_footer_logo.3b7a04fe374954de7f68af4a450985a6.svg","height":54,"width":54};